var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollMarker",style:({
        position: 'relative',
        width: '1px',
        height: '1px',
        opacity: 0,
        top: _vm.offsetBottom,
        left: _vm.offsetRight,
    })})}
var staticRenderFns = []

export { render, staticRenderFns }